import { IRecordScoreInput } from './manage-evaluations.interface';

type ScoreCell = Pick<IRecordScoreInput, 'playerAssessmentId' | 'drillId' | 'skillId' | 'round'>;

export const scoreCellPath = (score: ScoreCell): [string, string, string, number] =>
  [score.playerAssessmentId, score.drillId, score.skillId, score.round];

export const scoreCellKey = (score: ScoreCell): string => scoreCellPath(score).join('|');
